import downloadCloud from './DownloadCloud'
import download from './Download'
import fileAudio from './FileAudio'
import fileDoc from './FileDoc'
import fileImage from './FileImage'
import filePdf from './FilePdf'
import fileVideo from './FileVideo'
import folder from './Folder'
import uploadCloud from './UploadCloud'
import upload from './Upload'
import zip from './Zip'

export {
  downloadCloud,
  download,
  fileAudio,
  fileDoc,
  fileImage,
  filePdf,
  fileVideo,
  folder,
  uploadCloud,
  upload,
  zip
}
